<template>
    <BCard no-body>
      <BCardHeader class="pb-50">
        <h5> {{$t("Filters")}} </h5>
      </BCardHeader>
      <BCardBody>
        <BRow>
          <BCol cols="12" md="4" class="mb-md-0 mb-2" >
            <label>{{$t('Student')}}</label>
            <vSelect v-model="studentFilter" return-object :options="students" label="search_name" class="w-100" :reduce="val => val.id" v-if="students" @search="searchStudents"/>
          </BCol>
          <BCol cols="12" md="4" class="mb-md-0 mb-2" >
            <label>{{$t('Course')}}</label>
            <vSelect v-model="courseFilter" :options="courses" label="name" class="w-100" :reduce="val => val.id"  v-if="courses" @search="searchCourses"/>
          </BCol>
          <BCol cols="12" md="4" class="mb-md-0 mb-2" v-if="groups && groups.length>1">
            <label>{{ $t('Group') }}</label>
            <vSelect v-model="groupFilter" :options="groups" label="name" class="w-100" :reduce="val => val.id" v-if="groups" @search="searchGroups" />
          </BCol>
        </BRow>
      </BCardBody>
    </BCard>
  </template>

  <script>
  import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
  import { inject, watch, ref } from '@vue/composition-api';
  import vSelect from 'vue-select'
  import axios from '@axios'

  export default {
    components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
    setup(){
        const studentFilter = inject('studentFilter')
        const courseFilter = inject('courseFilter')
        const groupFilter = inject('groupFilter')
        const students = inject('students')
        const courses = inject('courses')
        const groups = inject('groups')

        const searchStudents=(value) => {
          if (value != ""){
            axios
              .get('/students', {params: {q:value} })
              .then(response => students.value=response.data.students)
          }
        }

        const searchCourses=(value) => {
          if (value != ""){
            axios
            .get('/courses', {params: {q:value} })
            .then(response => courses.value=response.data.courses)
          }
        }

        const searchGroups = (value) => {
          if (value != ""){
            axios
            .get('/groups', { params: { q: value } })
            .then(response => groups.value = response.data.groups)
          }
        }

        searchStudents()
        searchCourses()
        searchGroups()
       
        return {
            searchStudents,
            searchCourses,
            searchGroups,
            studentFilter,
            courseFilter,
            groupFilter,
            students,
            courses,
            groups
        }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
